import axios from '../../../boot/axios';
import { buildFetchUrl } from "../../../helpers/url";

export default {
    getLiveStatsNew({commit}) {
        return new Promise((resolve, reject) =>
            axios.post('getLiveStatsNew')
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err)));
    },
    postTip(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/postTip', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getFeeds(_) {
        return new Promise((resolve, reject) => {
            axios.get('api/v1/getFeeds')
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    getFeedsByUserId(_, {id}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getFeeds/${id}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    getFeedsByUserId_(_, {id, num}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getFeeds/${id}/${num}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    getMyPendingFeeds(_) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/feeds/pending`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    cashOut(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/cashout', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    postComment(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/postComment', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    toggleFollowUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/toggleFollowUser', payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    toggleFollowTip(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/toggleFollowTip/${payload.id}`)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    toggleLikeTip(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/toggleLikeTip/${payload.id}`)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    toggleFollowStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategy/follow/${payload.id}`)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    strategySwitch(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategySwitch`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    strategyBetfairSwitch(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategyBetfairSwitch`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    strategyTelegramSwitch(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategyTelegramSwitch`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    resetTip(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/resetTip', payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    getFixturesByDate(_, {date}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getFixturesByDate/${date}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    createStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategy`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },
    getUserStrategies(_, payload = {id: ''}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/strategy/user/${payload.id}`)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getUserStrategies_mini(_, payload) {
        let req_url = `api/v1/getStrategies_mini`;
        if (payload)
            req_url = `api/v1/getStrategies_mini/${payload.id}`;
        return new Promise((resolve, reject) => {
            axios.get(req_url)            
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    deleteStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(`api/v1/strategy/${payload.id}`)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getFeedsByStrategy(_, {id, userId}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/strategy/${id}/${userId}/feeds`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    getStatsByUserId(_, {id}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getStats/${id}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },    
    getStatsByStrategyId(_, {userId, strategyId}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getStats/${userId}/${strategyId}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    getStatsByStrategyId_(_, {userId, strategyId}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getStats_/${userId}/${strategyId}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },
    postCashoutRef(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/postCashoutRef', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    autoPostTip(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/autoPostTip', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    
    getAutoPostTips(_) {
        return new Promise((resolve, reject) => {
            axios.get('api/v1/getAutoPostTips')
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineCloneAction(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineCloneAction', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineStopAction(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineStopAction', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineStartAction(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineStartAction', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineDeleteAction(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineDeleteAction', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineEditAction(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineEditAction', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    deleteTip(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/deleteTip', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    deleteComment(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/deleteComment', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    editStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/editStrategy`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },

    deleteEventsByStrategy(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/deleteEventsByStrategy`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },

    getFeedsByStrategy_(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/getFeedsByStrategy_`, payload)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    getFeeds_(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getFeeds_', payload)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    getFinancialByStrategyId(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/getFinancialByStrategyId', payload)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    getFixtureById(_, {_id}) {
        return new Promise((resolve, reject) => {
            axios.get(`api/v1/getFixtureById/${_id}`)
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    strategyExcludeStats(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategyExcludeStats`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },

    strategyExcludeUsers(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`api/v1/strategyExcludeUsers`, payload)
            .then(({data: r}) => {
                resolve(r);
            }).catch(({response: {data: err}}) => reject(err)); 
        });
    },

    autoPostTipUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/autoPostTipUser', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    
    getAutoPostTipsUser(_) {
        return new Promise((resolve, reject) => {
            axios.get('api/v1/getAutoPostTipsUser')
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },

    getUserStrategies_mini_user(_, payload) {
        let req_url = `api/v1/getStrategies_mini_user`;
        if (payload)
            req_url = `api/v1/getStrategies_mini_user/${payload.id}`;
        return new Promise((resolve, reject) => {
            axios.get(req_url)            
                .then(({data: r}) => (
                    resolve(r)
                ))
                .catch(({response: {data: err}}) => reject(err));
        });
    },

    routineCloneActionUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineCloneActionUser', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineStopActionUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineStopActionUser', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineStartActionUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineStartActionUser', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineDeleteActionUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineDeleteActionUser', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    routineEditActionUser(_, payload) {
        return new Promise((resolve, reject) => {
            axios.post('api/v1/routineEditActionUser', payload)
                .then(({data: r}) => {
                    resolve(r);
                }).catch(({response: {data: err}}) => reject(err));
        });
    },
    getAlertSet_autopost(_, payload) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/getAlertSet_autopost', payload)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    postAlertSet_autopost(_, payload) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/postAlertSet_autopost', payload)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },    
    getTeams5YearStats(_, payload) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/getTeams5YearStats', payload)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
    getTeams5YearStatsDetail(_, payload) {
        return new Promise((resolve, reject) => 
            axios.post('api/v1/getTeams5YearStatsDetail', payload)
            .then(({data: r}) => {
                resolve(r);
            })
            .catch(({response: {data: err}}) => {
                reject(err);
            }));
    },
}